import styled from "styled-components";
import DashboardContainer from "../container/DashboardContainer";

const Container = styled.section``;

const Dashboard = () => {
  return (
    <Container>
      <DashboardContainer />
    </Container>
  );
};

export default Dashboard;
